import api from "./api";
import { Course, UpdateCourseData } from "../contexts/CourseContext";

export const getPaginatedCourses = async (params: any) => {
  const { data } = await api.get("/courses/paginated", { params });
  return data;
};

export const uploadFile = async (path: string, file: File) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post(`/upload/${path}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.path;
};

export const createCourse = async (
  courseData: Omit<Course, "_id" | "createdAt" | "updatedAt">,
  files?: { courseImage?: File; instructorAvatar?: File }
) => {
  let imagePath: string | undefined;
  let avatarPath: string | undefined;

  if (files?.courseImage) {
    imagePath = await uploadFile("courses", files.courseImage);
  }

  if (files?.instructorAvatar) {
    avatarPath = await uploadFile("instructors", files.instructorAvatar);
  }

  const payload = {
    ...courseData,
    image: imagePath,
    instructor: courseData.instructor
      ? {
          ...courseData.instructor,
          avatar: avatarPath,
        }
      : undefined,
  };

  const { data } = await api.post("/courses", payload);
  return data;
};

export const getCourses = async (params: any) => {
  const { data } = await api.get("/courses", { params });
  return data;
};

export const getCourseById = async (id: string) => {
  const { data } = await api.get(`/courses/${id}`);
  return data;
};

export const getCoursesByCategory = async (category: string) => {
  const { data } = await api.get(`/courses/category/${category}`);
  return data;
};

export const updateCourse = async (
  id: string,
  updateData: UpdateCourseData,
  files?: { courseImage?: File; instructorAvatar?: File }
) => {
  let imagePath: string | undefined;
  let avatarPath: string | undefined;

  if (files?.courseImage) {
    imagePath = await uploadFile("courses", files.courseImage);
  }

  if (files?.instructorAvatar) {
    avatarPath = await uploadFile("instructors", files.instructorAvatar);
  }

  const payload = {
    ...updateData,
    image: imagePath,
    instructor: updateData.instructor
      ? {
          ...updateData.instructor,
          avatar: avatarPath,
        }
      : updateData.instructor,
  };

  const { data } = await api.put(`/courses/${id}`, payload);
  return data;
};

export const deleteCourse = async (id: string) => {
  const { data } = await api.delete(`/courses/${id}`);
  return data;
};
